<section>
  <div class="mb-2">
    <div class="row">
      <p>Para realizar el proceso de importación de Clientes, descargue la guía y siga los pasos:</p>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-4 col-12 mt-2">
        <app-custom-button [title]="'Descargar Guía '" [label]="'Descargar Guía'" [severity]="'success'"
          [width]="'7rem'" (onClick)="downloadGuideImport()"></app-custom-button>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-9 d-flex flex-row justify-content-end gap-2 mt-2">
        <input type="file" id="fileImport" (change)="getNameFile($event)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden />
        <app-custom-button [title]="'Seleccionar archivo'" [label]="'Seleccionar archivo'" [variant]="undefined"
          [width]="'9rem'" (onClick)="attach()"></app-custom-button>
        <p class="ms-2 mt-2">{{nameFile}}</p>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-3 d-flex justify-content-end gap-2 mt-2">
        <app-custom-button [title]="'Importar'" [label]="'Importar'" [variant]="undefined" [severity]="'success'"
          (onClick)="importClients()"></app-custom-button>
      </div>
    </div>
    <div class="row">
      <div id="list" *ngIf="visibleTxt">
        <h6>Lista de Errores y Alertas</h6>
        <p>Total errores: {{clientAlerts.length}}</p>
        <div id="container-alerts" *ngFor="let clientAlert of clientAlerts">
          <p [ngClass]="errorClient == 1 ? 'message-error' : 'message-alert'">
            {{clientAlert.message}}
          </p>
        </div>
      </div>
      <div class="row" *ngIf="visibleTxt">
        <div class="d-flex justify-content-end">
          <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
            (onClick)="downloadErrorsTxt()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</section>